import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  ProjectStepLinkTypePicker,
  ProjectStepLinkTypePickerProps,
} from '@work4all/components/lib/components/entity-picker/project-step-link-type-picker/ProjectStepLinkTypePicker';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface Props
  extends Omit<ProjectStepLinkTypePickerProps<false>, 'multiple'> {
  error?: string;
}

export const ProjectStepLinkTypePickerField = React.forwardRef<
  HTMLDivElement,
  Props
>((props, ref) => {
  const { t } = useTranslation();
  const { error, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  return (
    <EntityPickerPopover
      picker={<ProjectStepLinkTypePicker {...pickerProps} multiple={false} />}
    >
      <PickerTargetButton
        ref={ref}
        onClear={() => {
          onChange(null);
        }}
        label={t('PROJECT_STEP_LINK_TYPE.LABEL')}
        error={error}
        value={value?.name || ''}
      />
    </EntityPickerPopover>
  );
});
